var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useState } from "react";
import { Search, List, Button } from "semantic-ui-react";
// import { ADD_GP_DISPLAY_TYPES } from "../consts";
import { GPItem } from "./GPItem";
import debounce from "@iscr/xAppLib/libs/debounce";
import API_service from "@iscr/xAppLib/providers/API_service";
const SEARCH_DEBOUNCE_MILISECONDS = 1000;
const INITIAL_RESULTS = 5;
const LOAD_MORE = 10;
/*
    search always returns false if the search term is less than 3 characters.
*/
const MIN_SEARCH_LENGTH = 3;
export const SearchGP = ({ selectedGP, setSelectedGP }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);
    const [totalDisplayedItemsCount, updateTotalDisplayedItemsCount] = useState(INITIAL_RESULTS);
    const [searchResults, setSearchResults] = useState([]);
    const handleSearchChange = (_event, result) => {
        const { value } = result;
        setSearchTerm(value || "");
        if (value && value.length >= MIN_SEARCH_LENGTH) {
            searchGPs(value);
        }
        else {
            setSearchResults([]);
        }
    };
    const searchGPs = useCallback(debounce((query) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setHasSearched(false);
            setIsLoading(true);
            const result = (yield API_service.api_promise(`referralnet/find_practitioner?query=${query}`));
            /*
                Need to format the results to match the GPPractitioner interface
                for backwards compatibility.
            */
            const formattedResults = result.map((_a) => {
                var { displayName, emailAddress } = _a, rest = __rest(_a, ["displayName", "emailAddress"]);
                return (Object.assign({ name: displayName, email: emailAddress }, rest));
            });
            setSearchResults(formattedResults);
        }
        catch (_a) {
            setSearchResults([]);
        }
        finally {
            /*
                Adding a small delay - so the search results get set before the loading state is reset
            */
            setTimeout(() => {
                setHasSearched(true);
                setIsLoading(false);
            }, 300);
        }
    }), SEARCH_DEBOUNCE_MILISECONDS), []);
    const handleResultSelect = (recipientId) => {
        const selectedResult = searchResults.find(result => result.recipientId === recipientId);
        setSelectedGP(selectedResult || null);
    };
    const onLoadMore = () => {
        updateTotalDisplayedItemsCount(prevCount => prevCount + LOAD_MORE);
    };
    const handleClearSearch = () => {
        setSearchTerm("");
        setSearchResults([]);
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "flex flex-row relative", children: [_jsx(Search, { className: "w-full  [&_input]:!rounded-full", open: false, input: {
                            fluid: true,
                            autoComplete: "false",
                            iconPosition: "left",
                        }, loading: isLoading, onSearchChange: handleSearchChange, value: searchTerm, fluid: true }), searchTerm && (_jsx("button", { type: "button", "aria-label": "Clear search", onClick: handleClearSearch, className: "absolute right-4 top-6 -translate-y-1/2 bg-transparent border-none cursor-pointer p-0 z-20", children: _jsx("span", { className: "text-lg text-gray-400", children: "\u00D7" }) }))] }), searchTerm && (_jsx(List, { divided: true, relaxed: true, children: !(searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) && searchTerm && hasSearched ? (_jsx("p", { className: "p-4", children: "No results found" })) : (searchResults.map((result, index) => {
                    const shouldDisplay = index < totalDisplayedItemsCount;
                    if (!shouldDisplay)
                        return null;
                    const isSelected = (selectedGP === null || selectedGP === void 0 ? void 0 : selectedGP.recipientId) === result.recipientId;
                    return (_jsx(GPItem, { isSelected: isSelected, handleResultSelect: isSelected ? () => setSelectedGP(null) : handleResultSelect, selectedGP: result }, index));
                })) })), !hasSearched && (_jsx("p", { className: "text-tertiary", children: "Please note: if your doctor cannot be found it is likely they are not in the database." })), searchResults.length > totalDisplayedItemsCount && (_jsx(Button, { type: "button", fluid: true, onClick: onLoadMore, className: "mt-4", children: "Load More" }))] }));
};
